import { Injectable } from '@angular/core';
import { HttpService } from '../core/http/http.service';
import { AuthService } from '../core/services/auth.service';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClassService {

  constructor(private httpApi: HttpService, private auth: AuthService,) { }

  findAll(options = { limit: true }) {

    if (!options.limit || this.auth.isAdmin) {
      return this.httpApi.list("dash/classes/active", options).toPromise()
    }
    const userClasses = this.auth.getClasses()

    return this.httpApi.list("dash/classes/active", options).pipe(
      map(data => data.filter(i => userClasses.includes(i.id)))
    ).toPromise()
  }

  findSectionsByClassId(classId: number) {
    return this.httpApi.list("dash/sections/class", { classId }).toPromise()
  }

  deleteById(id: number) {
    return this.httpApi.delete("dash/classes", id).toPromise()
  }
}
